<template>
    <div class="container" v-if="!mobil_mi">
        <div  class="row vh-100 d-flex justify-content-center align-items-center">
            <div class="col-6">
                <h1 class="text-center" style="font-size: 7rem;">!</h1>
                Bu uygulama sadece mobil cihazlar için tasarlanmıştır. Lütfen telefon veya tablet ile deneyiniz!
                Eğer telefon veya tablet kullanıyorsanız, tarayıcınız desktop sürümü istemek için ayarlanmış olabilir.
                Lütfen kapatınız!
            </div>
        </div>
        </div>
        <section v-if="mobil_mi"><img class="logo" src="@/assets/logo-banner.png" alt=""></section>
        <div class="container-fluid p-4">
        <div v-if="mobil_mi" class="row">
            <div class="col-md-12">
            <h1 class="tr text-start" v-html="kayit.baslik_tr"></h1>
            <h1 class="en text-start" v-html="kayit.baslik_en"></h1>
            </div>
            <div class="col-md-12 text-center pt-4">
                <img class="sergi-gorselleri" :src="'./assets/sergi-gorselleri/'+this.id+'.jpg'" />
            </div>
            <div id="icerik_tr" class="col-md-12 text-start pt-4" v-html="kayit.content_tr"></div>
            <div class="col-md-12 text-start pb-3"><hr class="p-0 mb-3"></div>
            <div id="icerik_en" class="col-md-12 text-start pb-0" v-html="kayit.content_en">

</div>
        </div>
    </div>
    <div  v-if="mobil_mi" class="container-fluid p-4 pt-3 pb-3" style=" background-color: #2c3e50;">
        <div class="row p-0">
            <div class="col-md-12 p-0">
               <p id="footer" class="p-0 m-0"><strong>Adalar Müzesi</strong> için <a href="https://extrarenk.com">ExtraRenk</a> tarafından hazırlanmıştır.<br>Copyright © 2023, Tüm Hakları Saklıdır.</p>
            </div>
        </div>
        </div>
</template>


<script>
export default {
    name: 'SuSergisi',
        data () {
            return {
                id:null,
                mobil_mi:true,
                kayit:null,
                kayitlar:[
                    {
                    id:1,
                    baslik_tr:'ÇEŞME KİTABESİ (?), <span class="kesilmesin">1911-12</span>',
                    baslik_en:'Fountain Inscription (?), <span class="kesilmesin">1911-12</span>',
                    content_tr:`<p>Enine oval kitabe içinde tepede Allah’a yakarış (Hû) ve altında üç satırda sülüs yazı. En altta Fatiha dileği ile tarih yazılı. </p>
                                <h5>Kitabenin okunuşu</h5>
                                <p>Hû<br>1284’de Saray-ı hümayuna dahil olup huzur-ı hazret-i Abdülhamid Han-ı sanide Bekçibaşılıkda bulunmuş olan Boyabadi Hacı Osman Nuri Efendi ruhuna Fatiha. Sene 1330. <p>
                                <h5>Kitabe hakkında bilgi</h5>
                                <p>Bu kitabe 1867 yılında sarayda göreve başlayıp sonraları 1876’da tahta geçen II. Abdülhamid’in Bekçibaşılığı görevini yürütmüş olan Hacı Osman Nuri Efendi’nin vefatı üzerine yazdırılmıştır. Osmanlı Arşivi belgeleri saray bekçilerinin büyük bir kısmının Boyabatlı olduğunu ortaya koyuyor. Kitabe kişinin ölümü üzerine düzenlenmiş olsa da  beklenen bir mezar taşı formatında olmadığı için bir hayratın üzerine konulduğunu tahmin edebiliriz. Muhtemelen bir çeşme kitabesi idi. Çeşmenin aslen nereden olduğu tespit edilemiyor. 1940’larda İstanbul çeşmelerini derleyen İbrahim Hilmi Tanışık’ın iki ciltlik İstanbul Çeşmeleri kitabı bu yazıta yer vermiyor. </p>
                                `,
                    content_en:`<p>A horizontally oblong inscription with an invocation to Allah (Hû) at the top and three lines of <span class="reg">sülüs</span> calligraphy below. At the bottom, the date is written along with a request for the recitation of al-Fatiha, the first chapter of the Quran. </p>
                                <h5>Transcription and translation</h5>
                                <p>Hû<br>
                                1284’de Saray-ı hümayuna dahil olup huzur-ı hazret-i Abdulhamid Han-ı sanide Bekçibaşılıkda bulunmuş olan Boyabadi Hacı Osman Nuri Efendi ruhuna Fatiha. Sene 1330. <p class="en">
                                <p>Hacı Osman Nuri Efendi of Boyabat, who joined the Imperial Palace in 1284 and served as the Head Guard of His Majesty Sultan Abdulhamid II, may his soul rest in peace. Year 1330. <p class="en">
                                <h5>Information about the inscription</h5>
                                <p>The inscription is written upon the passing of Hacı Osman Nuri Efendi, who began working at the palace in 1867 and later served as the Head Guard of Sultan Abdulhamid II (r. 1876-1909). Ottoman archive documents reveal that the majority of the Palace guards were from Boyabat. Although the inscription was designed upon the death of the mentioned person, its form does not correspond to that of a tombstone. It was most likely placed on a charitable endowment, possibly on a fountain. The original location of the structure cannot be determined. İbrahim Hilmi Tanışık's two-volume book <span class="reg">İstanbul Çeşmeleri</span>, a compilation of Istanbul's fountains in the 1940s, does not mention this inscription. </p>
                                `
                    },
                    {
                    id:2,
                    baslik_tr:'ÇEŞME KİTABESİ (?), <span class="kesilmesin">31 EKİM 1914</span>',
                    baslik_en:'Fountain Inscription (?), <span class="kesilmesin">October 31, 1914</span>',
                    content_tr:`<p>Tepede tek oval kartuş içinde Allah’ın “Hallak” ve “Baki” sıfatlarına yakarış, allta dört satıra dikdörtgen kartuşlar içine celî talik yazı. </p>
                                <h5>Kitabenin okunuşu</h5>
                                <p>Hüve’l-Hallak ül-Baki<br>
                                Ser-esvabi-i Hazret-i Şehriyari-i Esbak Ahmed Bey merhumun mahdumu Hırka-i saadet daire-i fahiresi mütehayyiranından Kaftan Ağası Hacı Fahreddin Beyin ruhu-içün el-Fatiha.
                                <br>18 Teşrin-i evvel, Sene 1330</p>
                                <h5>Kitabe hakkında bilgi</h5>
                                <p>31 Ekim 1914 tarihli kitabe Kaftan Ağası Hacı Fahreddin Bey’in vefatından sonra ruhuna Fatiha dilemek için yaptırılmıştır. Yazıt bir mezar taşı formatında olmadığı için aslen bir çeşmenin üstünde olduğu sanılıyor. Çeşmenin aslen nereden olduğu tespit edilemiyor. 1940’larda İstanbul çeşmelerini derleyen İbrahim Hilmi Tanışık’ın iki ciltlik İstanbul Çeşmeleri kitabı bu yazıta yer vermemiştir. Hacı Fahreddin Bey’in babasının Ser-esvabi Ahmed Bey’in olduğu anlaşılıyor.</p> `,
                    content_en:`<p>At the top, within a single oval cartouche, an invocation to Allah with the attributes of "Hallak" (Creator) and "Baki" (Everlasting). Below, in four lines of <span class="reg">celî talik</span> in rectangular cartouches. </p>
                                <h5>Transcription and translation</h5>
                                <p>Hüve’l-Hallak ül-Baki<br>
                                Ser-esvabi-i Hazret-i Şehriyari-i Esbak Ahmed Bey merhumun mahdumu Hırka-i saadet daire-i fahiresi mütehayyiranından Kaftan Ağası Hacı Fahreddin Beyin ruhu-içün el-Fatiha.
                                <br>18 Teşrin-i evvel, Sene 1330 </p>
                                <p>He is the Creator and Everlasting </p>
                                <p>Recite a prayer of al-Fatiha for the soul of Kaftan Ağası Hacı Fahreddin Bey, a benefactor of the Holy Mantle and son of the late Ahmed Bey, former chief servant in charge of the Sultan’s wardrobe. </p>
                                <p>18 Teşrin-i evvel (October), Year 1330.</p>
                                <h5>Information about the inscription</h5>
                                <p>Dated October 31, 1914, the inscription was commissioned to request prayers for the soul of Kaftan Ağası Hacı Fahreddin Bey following his passing. Since the inscription does not conform to the typical format of a tombstone, it is believed to have originally been placed on a fountain, the original location of which cannot be determined. Ibrahim Hilmi Tanışık's two-volume book <span class="reg">İstanbul Çeşmeleri</span>, a compilation of Istanbul's fountains in the 1940s, does not mention this inscription. Hacı Fahreddin Bey’s father was Ser-esvabi Ahmed Bey, in charge of the Sultan’s wardrobe.</p>
                                `
                    },
                    {
                    id:3,
                    baslik_tr:'ÇEŞME KİTABESİ, <span class="kesilmesin">1900-01</span>',
                    baslik_en:'Fountain Inscription (?), <span class="kesilmesin">1900-01</span>',
                    content_tr:`<p>Üç satır asimetrik kartuşlar içine celî talik yazı.</p>
                                <h5>Kitabenin okunuşu</h5>
                                <p>Celali Çeşmesinden iç ab u hayat olsun<br>
                                Sene 1318</p>
                                <h5>Kitabe hakkında bilgi</h5>
                                <p>Miladi 1900-01 yıllarında yapıldığı anlaşılan bu yazıt pek nadir bir çeşme kitabesidir. Vefat eden Osmanlı denizcilerinin ardından salınmış yelken, kırık direk, dümen, çapa vs. kabartmalarıyla mezar taşları yaptırıldığı biliniyor. Bu imgeleri kullanarak bir çeşme kitabesi olarak tek örnek elimizdeki bu Celali Çeşmesi’ne aittir. Çeşmenin aslen nereden olduğu tespit edilemiyor. 1940’larda İstanbul çeşmelerini derleyen İbrahim Hilmi Tanışık’ın iki ciltlik İstanbul Çeşmeleri kitabı bu yazıta yer vermiyor. Muhtemelen o yıllarda kitabe özel kolleksiyona geçmişti.</p>
                                `,
                    content_en:`<p>Three lines of asymmetrical cartouches inscribed in <span class="reg">celî tali</span> script.</p>
                                <h5>Transcription and translation</h5>
                                <p>Celali Çeşmesinden iç ab u hayat olsun<br>
                                Sene 1318</p>
                                <p>Drink from the water of Celali Fountain. May it be the Elixir of eternal life.<br>
                                Year 1318.</p>
                                <h5>Information about the inscription</h5>
                                <p>Dating back to the years 1900-01, this is a rare fountain inscription. It is known that tombstones were commissioned after the passing of Ottoman seafarers, featuring reliefs of lowered sails, broken masts or rudders, anchors, etc. This is the only example of a fountain inscription that features these symbols. The original location of the structure cannot be determined. İbrahim Hilmi Tanışık's two-volume book <span class="reg">İstanbul Çeşmeleri</span>, a compilation of Istanbul's fountains in the 1940s, does not mention this inscription. It was possibly already in a private collection in those years.</p>
                                `
                    },
                    {
                    id:4,
                    baslik_tr:'YALI (?) KİTABESİ PARÇASI, <span class="kesilmesin">19. YÜZYIL BAŞI (?)</span>',
                    baslik_en:'Seaside mansion (?) Inscription Fragment, <span class="kesilmesin">Early 19<sup>th</sup> Century (?)</span>',
                    content_tr:`
                    <p>Tek satırda iki değişik kalınlıkta kalem ile yazılmış celî sülüs yazı.</p>
                    <h5>Kitabenin okunuşu</h5>
                    <p>… başlıkla ber-murad olan yalı sahibi Çavuşbaşı el-Hac Mehmed Ağa. Selamun aleyk…</p>
                    <h5>Kitabe hakkında bilgi</h5>
                    <p>Başı ve sonu eksik olan bu kitabede Çavuşbaşı Hacı Mehmed Ağa’nın adı geçmektedir. Elimizde bulunan parçadan anlaşıldığı gibi gerçekten bu yazıt bir yalı için hazırlanmış ise oldukça nadir bir sivil mimari kitabesi olarak düşünmek gerekiyor. Çavuşbaşılık görevi 1826’da yeniçeriliğin kaldırılmasından sonra önemini kaybedecektir. Türkçe yazılan ilk kısım ince kalemle, sondaki kısım ise daha kalın bir kalemle yazılmıştır.</p>
                    `,
                    content_en:`
                    <p>A single line of <span class="reg">celî sülüs</span> script written in two different sizes of reeds.</p>
                    <h5>Transcription and translation</h5>
                    <p>… başlıkla ber-murad olan yalı sahibi Çavuşbaşı el-Hac Mehmed Ağa. Selamun aleyk…</p>
                    <p>…acceded to the chief of…seaside mansion owner Çavuşbaşı el-Hac Mehmed Ağa. May peace be upon…</p>
                    <h5>Information about the inscription</h5>
                    <p>This incomplete inscription mentions the name of Çavuşbaşı Hacı Mehmed Ağa. If this inscription was indeed prepared for a seaside mansion (<span class="reg">yalı</span>), -as can be deduced from the fragment- it should be considered a rare example of a dedication tablet for civilian architecture. The position of Çavuşbaşı (Chief Sergeant at the Imperial Palace) lost its significance after the abolition of the Janissary Corps in 1826. The first part of the inscription written in Turkish is inscribed with a fine reed, whereas the part at the end is inscribed with a thicker reed.</p>
                    `
                    },
                    {
                    id:5,
                    baslik_tr:'II. ABDÜLHAMİD’İN TUĞRASI, <span class="kesilmesin">1878-79</span>',
                    baslik_en:'Imperial Monogram of Abdulhamıd II, <span class="kesilmesin">1878-79</span>',
                    content_tr:`
                    <p>Tek satırda iki değişik kalınlıkta kalem ile yazılmış celî sülüs yazı.</p>
                    <h5>Kitabenin okunuşu</h5>
                    <p>… başlıkla ber-murad olan yalı sahibi Çavuşbaşı el-Hac Mehmed Ağa. Selamun aleyk…</p>
                    <h5>Kitabe hakkında bilgi</h5>
                    <p>Başı ve sonu eksik olan bu kitabede Çavuşbaşı Hacı Mehmed Ağa’nın adı geçmektedir. Elimizde bulunan parçadan anlaşıldığı gibi gerçekten bu yazıt bir yalı için hazırlanmış ise oldukça nadir bir sivil mimari kitabesi olarak düşünmek gerekiyor. Çavuşbaşılık görevi 1826’da yeniçeriliğin kaldırılmasından sonra önemini kaybedecektir. Türkçe yazılan ilk kısım ince kalemle, sondaki kısım ise daha kalın bir kalemle yazılmıştır.</p>
                    `,
                    content_en:`
                    <p>A single line of celî sülüs script written in two different sizes of reeds.</p>
                    <h5>Transcription and translation</h5>
                    <p>… başlıkla ber-murad olan yalı sahibi Çavuşbaşı el-Hac Mehmed Ağa. Selamun aleyk…</p>
                    <p>…acceded to the chief of…seaside mansion owner Çavuşbaşı el-Hac Mehmed Ağa. May peace be upon…</p>
                    <h5>Information about the inscription</h5>
                    <p>This <span class="reg">tughra</span>, or the Imperial Monogram, engraved during the early years of the reign of Abdülhamid II (r.1876-1909) bears the date 1296 AH (1878-79 AD). The meticulous stone craftsmanship is noteworthy. The floral ornamentation found on the upper right side of Abdülhamid's <span class="reg">tughra</span> was replaced with the title "al-Ghazi" in the later years of this sultan’s reign. The <span class="reg">tughra</span> was inscribed by renowned calligrapher of <span class="reg">celî talik</span> and <span class="reg">sülüs</span> scripts Sami Efendi (1838-1912). It is likely that the inscription was placed on a charitable endowment structure commissioned by the sultan, but its exact nature and location cannot be determined.</p>
                    `
                    },
                    {
                    id:6,
                    baslik_tr:'KUYU BİLEZİKLERİ, <span class="kesilmesin">19. YÜZYIL</span>',
                    baslik_en:'Well curbs, <span class="kesilmesin">19<sup>th</sup> century</span>',
                    content_tr:`
                    <p>Müzemizde üç adet kuyu bileziği bulunuyor. Kuyu bilezikleri kuyuların ağzına yere oturtulurdu. Bazen üzerindeki bir çıkrık, bazen ipin ucundaki bir kova vasıtasıyla su çekilirdi. Örneklerimizden ikisi zemin taşları ile beraber sergilenmekte. Ön taraftaki diğerinin ise kitabesi bulunmaktadır. Kitabenin okunuşu ve yaptıran hakkında bilgi aşağıdadır.</p>
                    <p>Kitabeli su bileziği (önde)</p>
                    <p>İki satır kartuş içinde istifli sülüs yazı. Altta ortada tarih 1 Ağustos 1881’e karşılık geliyor.</p>
                    <h5>Kitabenin okunuşu</h5>
                    <p>Devletlü Baş İkbal Hüsnümelek Hanım Efendi Hazretlerinin Baş Ağası Mehmet Safvet Ağanın hayratıdır.</p>
                    <p>5 Ramazan Sene 1298</p>
                    <h5>Kitabe hakkında bilgi</h5>
                    <p>İstanbul’da günümüze kalan nadir kuyu bileziği kitabelerinden birisi olan bu yazıt II. Mahmud’un (saltanatı 1808-1839) Baş İkbali, yani padişahın en kıdemli odalığı olan Hüsnümelek Hanım’ın Baş Ağalığını yapmış Safvet Ağa tarafından 1881 yılında yaptırılmıştır. Kuyunun asıl yeri tespit edilemiyor.</p>
                    `,
                    content_en:`
                    <p>The museum collection features three well curbs. Well curbs were placed on the ground at the mouth of wells. Sometimes, water was drawn using a winch on top and a bucket at the end of a rope. Two of our examples are displayed along with the ground stones. The third in the front has an inscription. The transcription of the inscription and information about its commissioner can be found below.</p>
                    <p>Well curb with inscription (in front)</p>
                    <p>Stacked <span class="reg">cülüs</span> calligraphy within two lines of cartouches. The date written in the center at the bottom corresponds to August 1, 1881.</p>
                    <h5>Transcription and translation</h5>
                    <p>Devletlü Baş İkbal Hüsnümelek Hanım Efendi Hazretlerinin Baş Ağası Mehmet Safvet Ağanın hayratıdır.</p>
                    <p>5 Ramazan Sene 1298</p>
                    <p>This is the charitable deed of Chief Agha Mehmet Safvet, who served the esteemed Chief Consort Hüsnümelek Hanım Efendi.<br>
                    5 Ramazan, Year 1298 (AH).</p>
                    <h5>Information about the inscription</h5>
                    <p>Well curbs with inscriptions are rare in Istanbul. This one was commissioned in 1881 by Safvet Ağa, who served Hüsnümelek Hanım, the most senior lady-in-waiting to Sultan Mahmud II (reigned 1808-1839). The original location of the well cannot be determined.</p>
                    `
                    },
                    {
                    id:7,
                    baslik_tr:'ÇEŞME AYNA TAŞI, <span class="kesilmesin">18. YÜZYIL (?)</span>',
                    baslik_en:'Fountain Slab, <span class="kesilmesin">18<sup>th</sup> century (?)</span>',
                    content_tr:`
                    <p>Çeşmenin vazgeçilmez bir elemanı olan ayna taşı, çeşmelerde musluğun takıldığı, çoğu oymalarla süslü düşey taştır.</p>
                    <h5>Taş hakkında bilgi</h5>
                    <p>Bu ayna taşının tepesindeki kartuş içinde muhtemelen bir kısa kitabe vardı. Yazının kazınarak silindiği anlaşılıyor. Özellikle İstanbul’daki kimi kitabelerin 1928’deki harf devriminden sonra yok edildiği biliniyor. Su lüleleri için kullanılan deliklerin etrafındaki floral kabartmalar 18. yüzyılın ikinci yarısına tarihlenebilir. Çeşmenin asıl yeri tespit edilemiyor. </p>
                    `
                    ,
                    content_en:`
                    <p>An integral part of the fountain, the slab, often ornate with decorations, is the vertical stone to which the spout is attached.</p>
                    <h5>Information about the slab</h5>
                    <p>This marble fountain slab likely had a short inscription inside the cartouche at the top. It appears that the inscription has been intentionally scraped off.  Some inscriptions in Istanbul were destroyed after the alphabet reform of 1928. The floral reliefs flanking the holes used for waterspouts can be dated to the second half of the 18th century. The original location of the fountain cannot be determined.</p>
                    `
                    },

            ]
            }
        },
    created (){
        const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
        });
        this.id = params.id
        this.kayit = this.kayitlar[params.id-1]
    }
    ,methods: {
    }
}

</script>

<style>
.logo{
    width: 100%;
}
h1.tr{
    font-family: poppins, sans-serif;
    font-weight: 500;
    font-style: normal;
    text-transform: uppercase; font-size: 1.6rem !important;
    color: #1a2b3b;
}
h1.en{
    font-family: poppins, sans-serif;
    font-weight: 200 !important;
    font-style: italic;
    text-transform: uppercase; font-size: 1.6rem !important;
    color: #1a2b3b;
}

#icerik_tr h5{
    font-family: poppins, sans-serif;
    font-weight: 600;
    font-style: normal;
    font-size: 1rem !important;
    color: #1a2b3bd9;
}
#icerik_en h5{
    font-family: poppins, sans-serif;
    font-weight: 600 !important;
    font-style: italic;
    font-size: 1rem !important;
    color: #1a2b3bd9;
}

sup{text-transform: lowercase !important;}

#icerik_tr p{
    font-family: poppins, sans-serif;
    font-weight: 400;
    font-style: normal;
    color: #2c3e50;
}
#icerik_en p {
    font-family: poppins, sans-serif;
    font-weight: 300 !important;
    font-style: italic;
    color: #1a2b3b;
}

.sergi-gorselleri{ height: 228px; max-width: 100% !important;}
#footer{
    font-family: poppins, sans-serif;
    font-weight: 300 !important;
    font-style: normal;
    color: azure;
    font-size: 0.7rem;
    line-height: 1.2rem;
    text-align: center !important;
    }
.kesilmesin{white-space: nowrap;}
a{ text-decoration: none !important; color: azure !important; font-weight: 600;}
strong{ font-weight: 600;}
.reg{ font-style: normal !important;}






</style>